import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { MgpGaugeChart } from '../components/MgpGaugeChart/MgpGaugeChart';
import { goalsSelector } from '../MoneyGuidProSelectors';
import { goalsReducerPrefix } from '../MoneyGuideProConstants';
import LoadingMask from '../../CommonComponents/LoadingMask';
import { ResultsWrapper, ResultsHeading, ResultsText } from './GoalsStyles';
import { TabProps } from '../MoneyGuideProTypes';
import { Tab } from '../Tab/Tab';

export const Goals: React.FC<TabProps> = ({ id, clientId }) => {
  const data = useSelector(goalsSelector);

  const LoadingState = useMemo(
    () => (
      <>
        <MgpGaugeChart />
        <ResultsWrapper>
          <ResultsHeading>Results</ResultsHeading>
          <LoadingMask width="400px" height="20px" isDark />
          <br />
          <LoadingMask width="300px" height="20px" isDark />
        </ResultsWrapper>
      </>
    ),
    [],
  );

  const EmptyState = useMemo(
    () => (
      <>
        <MgpGaugeChart />
        <ResultsWrapper>
          <ResultsHeading>Results</ResultsHeading>
          <ResultsText>There is no information to display</ResultsText>
        </ResultsWrapper>
      </>
    ),
    [],
  );

  return (
    <Tab
      tabTitle="Reaching Your Goals"
      mgpItemId={id}
      clientId={clientId}
      asOfDate={data ? data.asOfDate : null}
      reducerPrefix={goalsReducerPrefix}
      isEmpty={data === null}
      isPristine={data === undefined}
      LoadingState={LoadingState}
      EmptyState={EmptyState}
    >
      {data ? (
        <div>
          <MgpGaugeChart data={data.chartData} />
          {typeof data.chartData.value === 'number' && (
            <ResultsWrapper>
              <ResultsHeading>Results</ResultsHeading>
              <ResultsText>
                If you implement the following suggestion, there is a{' '}
                {Math.round(data.chartData.value)}% likelihood of funding all of the financial goals
                in your plan.
              </ResultsText>
            </ResultsWrapper>
          )}
        </div>
      ) : null}
    </Tab>
  );
};
